import { render } from "./imagenprimera.vue?vue&type=template&id=1e2fc050&scoped=true"
import script from "./imagenprimera.vue?vue&type=script&lang=js"
export * from "./imagenprimera.vue?vue&type=script&lang=js"

import "./imagenprimera.vue?vue&type=style&index=0&id=1e2fc050&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e2fc050"]])

export default __exports__